import { Button, FormControl } from 'react-bootstrap';
import PT from 'prop-types';
import Immutable from 'immutable';

import HintPopover from '../Question/HintPopover';
import { createInstructionMarkup, questionComponentPropTypes } from './helpers';
import style from './JeddleFreeTextQuestion.scss';

const JeddleFreeTextQuestion = ({
  question,
  response,
  isSaving,
  isAnswered,
  onResponseChange,
  onSaveClick,
  onContinue,
}) => {
  const handleResponseChange = (e) => {
    onResponseChange(response.set('answer', e.target.value));
  };

  const hintHtml = question.get('jeddle_hint_html');
  const answerValue = response?.get('answer') ?? '';
  const hasAnswer =
    typeof answerValue === 'string' && answerValue.trim().length > 0;

  return (
    <div className="question text-question">
      <span dangerouslySetInnerHTML={createInstructionMarkup(question)} />
      <FormControl
        componentClass="textarea"
        rows={question.get('textarea_height')}
        placeholder="Write your answer"
        value={answerValue}
        onChange={handleResponseChange}
        disabled={isSaving || isAnswered}
      />

      {hintHtml && (
        <div className={style.hint}>
          <HintPopover hint={hintHtml} />
        </div>
      )}

      {isAnswered ? (
        <div className={style.actions}>
          <Button onClick={onContinue}>Continue &raquo;</Button>
        </div>
      ) : (
        <div className={style.actions}>
          <Button onClick={onSaveClick} disabled={!hasAnswer || isSaving}>
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

JeddleFreeTextQuestion.propTypes = {
  ...questionComponentPropTypes,
  onContinue: PT.func.isRequired,
  isAnswered: PT.bool,
};

JeddleFreeTextQuestion.defaultProps = {
  response: Immutable.Map(),
  isAnswered: false,
};

export default JeddleFreeTextQuestion;
